'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { verticalNavListStyles } from './styles/vertical-nav-list.styles';
import type { VerticalNavListPropsInterface } from './types/vertical-nav-list.types';

/**
 * @since 8.14.0
 */
export const VerticalNavList = forwardRef<HTMLOListElement, VerticalNavListPropsInterface>(
  (props: VerticalNavListPropsInterface, forwardedRef) => {
    const { className, css: cssProp, ...rest } = props;

    const styles = css(verticalNavListStyles, cssProp);

    return (
      <ol
        ref={forwardedRef}
        data-c11n-component="VerticalNav.List"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_vertical-nav__list', styles, className)}
        {...rest}
      />
    );
  },
);

VerticalNavList.displayName = 'VerticalNav.List';
